module.exports = __webpack_public_path__ + "media/icons/calculator-icon-131ca76e.png";